import React, { useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../Can";

// Barra de abas interna compartilhada pelas telas do módulo Campanhas
// (/campaigns, /contact-lists, /files). Configurações deixou de ser aba:
// virou modal aberto pela engrenagem no header de /campaigns (o deep link
// /campaigns-config segue funcionando). Substitui o
// antigo submenu da sidebar — estilo das abas do mockup Configurações A
// (docs/design/aeros-dark/mockups/Telas Aeros Dark - Kanban, Campanhas e
// Configurações.dc.html).
const useStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  return {
    tabsBar: {
      display: "flex",
      gap: 2,
      flexShrink: 0,
      borderBottom: `1px solid ${
        isLight ? theme.palette.divider : "rgba(255,255,255,0.08)"
      }`,
      marginBottom: theme.spacing(2),
    },
    tab: {
      appearance: "none",
      background: "none",
      border: "none",
      borderBottom: "2px solid transparent",
      cursor: "pointer",
      fontFamily: "inherit",
      padding: "10px 18px",
      fontSize: 13,
      fontWeight: 500,
      color: theme.palette.text.secondary,
      "&:hover": {
        color: theme.palette.text.primary,
      },
    },
    tabActive: {
      fontWeight: 700,
      color: theme.palette.text.primary,
      borderBottom: "2px solid",
      borderImage: "linear-gradient(90deg,#A044FF,#22D3EE) 1",
    },
  };
});

const TABS = [
  { to: "/campaigns", labelKey: "campaigns.subMenus.list" },
  { to: "/contact-lists", labelKey: "campaigns.subMenus.listContacts" },
  { to: "/files", labelKey: "campaigns.subMenus.files", perform: "dashboard:view" },
];

const CampaignsNav = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { user } = useContext(AuthContext);

  // O deep link /campaigns-config renderiza a página /campaigns (com o
  // modal de configurações aberto) — a aba "Listagem" segue ativa.
  const pathname =
    location.pathname === "/campaigns-config" ? "/campaigns" : location.pathname;

  const isActive = (to) =>
    pathname === to || pathname.startsWith(`${to}/`);

  const renderTab = ({ to, labelKey }) => (
    <button
      key={to}
      type="button"
      className={`${classes.tab} ${isActive(to) ? classes.tabActive : ""}`}
      aria-current={isActive(to) ? "page" : undefined}
      onClick={() => history.push(to)}
    >
      {i18n.t(labelKey)}
    </button>
  );

  return (
    <nav className={classes.tabsBar} aria-label={i18n.t("campaigns.title")}>
      {TABS.map((tab) =>
        tab.perform ? (
          <Can
            key={tab.to}
            role={user.profile}
            perform={tab.perform}
            yes={() => renderTab(tab)}
          />
        ) : (
          renderTab(tab)
        )
      )}
    </nav>
  );
};

export default CampaignsNav;
